import { default as _91slug_93DGyjtwe0Q8Meta } from "/usr/src/app/workspace/web/pages/articles/[slug].vue?macro=true";
import { default as indexMz7BPYjcCkMeta } from "/usr/src/app/workspace/web/pages/articles/index.vue?macro=true";
import { default as collectionsJxLL55iWHkMeta } from "/usr/src/app/workspace/web/pages/collections/[slug]/collections.vue?macro=true";
import { default as indexGZWRE1GnhLMeta } from "/usr/src/app/workspace/web/pages/collections/[slug]/index.vue?macro=true";
import { default as index3AW2RUyt4pMeta } from "/usr/src/app/workspace/web/pages/collections/index.vue?macro=true";
import { default as forgotpasswordVCKN2uCZT5Meta } from "/usr/src/app/workspace/web/pages/forgotpassword.vue?macro=true";
import { default as indexigEN1OVRboMeta } from "/usr/src/app/workspace/web/pages/index.vue?macro=true";
import { default as _91slug_93WjduXQZGRxMeta } from "/usr/src/app/workspace/web/pages/people/[slug].vue?macro=true";
import { default as _91slug_93bDscjMKIpHMeta } from "/usr/src/app/workspace/web/pages/podcasts/[slug].vue?macro=true";
import { default as indexZMjuphEh6OMeta } from "/usr/src/app/workspace/web/pages/podcasts/index.vue?macro=true";
import { default as editWbx1F2u9anMeta } from "/usr/src/app/workspace/web/pages/profile/edit.vue?macro=true";
import { default as index2HHJwDwAqHMeta } from "/usr/src/app/workspace/web/pages/profile/index.vue?macro=true";
import { default as search3vjCXxExU7Meta } from "/usr/src/app/workspace/web/pages/search.vue?macro=true";
import { default as signinCatr1nLooRMeta } from "/usr/src/app/workspace/web/pages/signin.vue?macro=true";
import { default as signoutUyQNQyg1mSMeta } from "/usr/src/app/workspace/web/pages/signout.vue?macro=true";
import { default as signupG4s12j3veGMeta } from "/usr/src/app/workspace/web/pages/signup.vue?macro=true";
import { default as indexf7IIYClW6EMeta } from "/usr/src/app/workspace/web/pages/studies/[slug]/[sessionslug]/index.vue?macro=true";
import { default as indexgIPKL9cnHGMeta } from "/usr/src/app/workspace/web/pages/studies/[slug]/index.vue?macro=true";
import { default as index27BDdpH0WaMeta } from "/usr/src/app/workspace/web/pages/studies/index.vue?macro=true";
import { default as _91slug_93rozzMGQfd9Meta } from "/usr/src/app/workspace/web/pages/talks/[slug].vue?macro=true";
import { default as indexaas0Lr0BZBMeta } from "/usr/src/app/workspace/web/pages/talks/index.vue?macro=true";
import { default as _91slug_93Irutrue3LuMeta } from "/usr/src/app/workspace/web/pages/topics/[slug].vue?macro=true";
import { default as index9WIrVVHJYzMeta } from "/usr/src/app/workspace/web/pages/wordpress-sync/index.vue?macro=true";
import { default as _91slug_93vMzjbZIPbJMeta } from "/usr/src/app/workspace/web/pages/worship/[slug].vue?macro=true";
import { default as indexRPA2r1j7QlMeta } from "/usr/src/app/workspace/web/pages/worship/index.vue?macro=true";
import { default as component_45stubuAqErgeg8kMeta } from "/usr/src/app/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_magicast_xbkzymk6izycllcza445pdgroq/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubuAqErgeg8k } from "/usr/src/app/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_magicast_xbkzymk6izycllcza445pdgroq/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "articles-slug___en",
    path: "/articles/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/articles/[slug].vue")
  },
  {
    name: "articles___en",
    path: "/articles",
    meta: indexMz7BPYjcCkMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/articles/index.vue")
  },
  {
    name: "collections-slug-collections___en",
    path: "/collections/:slug()/collections",
    component: () => import("/usr/src/app/workspace/web/pages/collections/[slug]/collections.vue")
  },
  {
    name: "collections-slug___en",
    path: "/collections/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/collections/[slug]/index.vue")
  },
  {
    name: "collections___en",
    path: "/collections",
    component: () => import("/usr/src/app/workspace/web/pages/collections/index.vue")
  },
  {
    name: "forgotPassword___en",
    path: "/forgotpassword",
    meta: forgotpasswordVCKN2uCZT5Meta || {},
    component: () => import("/usr/src/app/workspace/web/pages/forgotpassword.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/usr/src/app/workspace/web/pages/index.vue")
  },
  {
    name: "people-slug___en",
    path: "/people/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/people/[slug].vue")
  },
  {
    name: "podcasts-slug___en",
    path: "/podcasts/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/podcasts/[slug].vue")
  },
  {
    name: "podcasts___en",
    path: "/podcasts",
    meta: indexZMjuphEh6OMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/podcasts/index.vue")
  },
  {
    name: "profileSettings___en",
    path: "/profile/edit",
    meta: editWbx1F2u9anMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/profile/edit.vue")
  },
  {
    name: "myProfile___en",
    path: "/profile",
    meta: index2HHJwDwAqHMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/profile/index.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: search3vjCXxExU7Meta || {},
    component: () => import("/usr/src/app/workspace/web/pages/search.vue")
  },
  {
    name: "signin___en",
    path: "/signin",
    meta: signinCatr1nLooRMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/signin.vue")
  },
  {
    name: "signout___en",
    path: "/signout",
    meta: signoutUyQNQyg1mSMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/signout.vue")
  },
  {
    name: "signup___en",
    path: "/signup",
    meta: signupG4s12j3veGMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/signup.vue")
  },
  {
    name: "studies-slug-sessionslug___en",
    path: "/studies/:slug()/:sessionslug()",
    component: () => import("/usr/src/app/workspace/web/pages/studies/[slug]/[sessionslug]/index.vue")
  },
  {
    name: "studies-slug___en",
    path: "/studies/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/studies/[slug]/index.vue")
  },
  {
    name: "studies___en",
    path: "/studies",
    meta: index27BDdpH0WaMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/studies/index.vue")
  },
  {
    name: "talks-slug___en",
    path: "/talks/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/talks/[slug].vue")
  },
  {
    name: "messages___en",
    path: "/talks",
    meta: indexaas0Lr0BZBMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/talks/index.vue")
  },
  {
    name: "topics-slug___en",
    path: "/topics/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/topics/[slug].vue")
  },
  {
    name: "wordpress-sync___en",
    path: "/wordpress-sync",
    component: () => import("/usr/src/app/workspace/web/pages/wordpress-sync/index.vue")
  },
  {
    name: "worship-slug___en",
    path: "/worship/:slug()",
    component: () => import("/usr/src/app/workspace/web/pages/worship/[slug].vue")
  },
  {
    name: "worship___en",
    path: "/worship",
    meta: indexRPA2r1j7QlMeta || {},
    component: () => import("/usr/src/app/workspace/web/pages/worship/index.vue")
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/topic/:pathMatch(.*)",
    component: component_45stubuAqErgeg8k
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/songs/:pathMatch(.*)",
    component: component_45stubuAqErgeg8k
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/messages/:pathMatch(.*)",
    component: component_45stubuAqErgeg8k
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/devotionals/:pathMatch(.*)",
    component: component_45stubuAqErgeg8k
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/tracks/:pathMatch(.*)",
    component: component_45stubuAqErgeg8k
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/today",
    component: component_45stubuAqErgeg8k
  },
  {
    name: component_45stubuAqErgeg8kMeta?.name,
    path: "/discover",
    component: component_45stubuAqErgeg8k
  }
]